import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { Link } from 'react-router-dom';
import { Icon, Menu, Dropdown } from 'antd';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import { withNamespaces } from 'react-i18next';
import i18n from '../../i18n';

import classes from './AdminHeader.css';

import {
  getUserToken,
  getPatientProfileReadPermission,
  getSAEReadPermission,
  getFollowUp90dReadPermission,
  getAdminSettingsPermission,
  getUserInfo, getSiteReadPermission, getRoleReadPermission, getUserReadPermission,
  getDocumentReadPermission,
  getDocumentTrainingReadPermission,
  getDocumentPublicReadPermission,
  getAuditLogReadPermission,
  getSimulationReadPermission,
  getUserTrainingReadPermission,
  getNewsletterReadPermission,
  getReportsReadPermission,
} from "../../reducers/user/selectors";
import { logout } from "../../reducers/user/actions";
import actLogo from "../../assets/img/act_quicr_logo_red_white.png";

const routes = require('../../routes.json');

const menuPatients = (props) => (
  <Menu>
    {props.patientProfileReadPermission && (<Menu.Item>
      <Link to={routes.admin.patientProfile}>
        + Patient profile
      </Link>
    </Menu.Item>)}
    {props.followUp90dReadPermission && (<Menu.Item>
      <Link to={routes.admin.followUp90Day}>
        + 90-day follow-up
      </Link>
    </Menu.Item>)}
    {props.SAEReadPermission && (<Menu.Item>
      <Link to={routes.admin.saeReporting}>
        + Record SAE
      </Link>
    </Menu.Item>)}
    {props.patientProfileReadPermission && (<Menu.Item>
      <Link to={routes.admin.enrolments}>
        View all enrolments
      </Link>
    </Menu.Item>)}
    {/*{props.patientProfileReadPermission && (<Menu.Item>
      <Link to={routes.admin.patientList}>
        View all patients
      </Link>
    </Menu.Item>)}*/}
  </Menu>
);

const menuManageTrial = (props) => (
  <Menu>
    {props.siteReadPermission && <Menu.Item>
      <Link to={routes.admin.settingsSites} rel="noopener noreferrer">
        + Site
      </Link>
    </Menu.Item>}
    {props.roleReadPermission && <Menu.Item>
      <Link to={routes.admin.settingsRoles} rel="noopener noreferrer">
        + Role
      </Link>
    </Menu.Item>}
    {props.userReadPermission && <Menu.Item>
      <Link to={routes.admin.settingsUsers} rel="noopener noreferrer">
        + User
      </Link>
    </Menu.Item> }
  </Menu>
);
const menuTrialResources = props => (
  <Menu>
    {props.documentTrainingReadPermission && <Menu.Item>
      <Link to={routes.admin.documentsTraining} rel="noopener noreferrer">
        Training Documents
      </Link>
    </Menu.Item>}
    {props.documentPublicReadPermission && <Menu.Item>
      <Link to={routes.admin.documentsPublic} rel="noopener noreferrer">
        Public Documents
      </Link>
    </Menu.Item>}
    {props.auditLogReadPermission && <Menu.Item>
      <Link to={routes.admin.auditLogs} rel="noopener noreferrer">
        Audit logs
      </Link>
    </Menu.Item>}
    {props.simulationReadPermission && <Menu.Item>
      <Link to={routes.admin.simulation} rel="noopener noreferrer">
        Simulation
      </Link>
    </Menu.Item>}
    {props.userTrainingReadPermission && <Menu.Item>
      <Link to={routes.admin.training} rel="noopener noreferrer">
        Training
      </Link>
    </Menu.Item>}
  </Menu>
);

class AdminHeader extends React.Component {
  changeLang = lang => () => {
    window.localStorage.setItem('lang', lang);
    i18n.changeLanguage(lang);
  };

  render() {
    const { logout, patientProfileReadPermission, SAEReadPermission, newsletterReadPermission, reportsReadPermission, followUp90dReadPermission, adminSettingsPermission, userInfo, simulationReadPermission, userTrainingReadPermission, documentTrainingReadPermission, documentPublicReadPermission, documentReadPermission, auditLogReadPermission, t } = this.props;

      return (
        <div className={classes.header}>
          <div className={classes.headerProfile}>
            <Link to="/admin" className={classes.headerProfileLogo}><img alt="act" src={actLogo} /></Link>

            <div className={classes.headerProfileLinksWrapper}>
              <div className={classes.headerProfileLinksLeft}>
                {/*<span onClick={this.changeLang('en')}>En</span>
                &nbsp;|&nbsp;
                <span onClick={this.changeLang('ro')}>Ro</span>
                &nbsp;&nbsp;*/}
                <span className={classes.headerProfileUsername}>Welcome, {get(userInfo, 'first_name') ? `${get(userInfo, 'first_name')}` : get(userInfo, 'email') }
                &nbsp; |&nbsp;</span>
                {adminSettingsPermission && <Link to={routes.admin.settings} className={classNames(classes.headerProfileLink)}>Admin settings</Link>}
                <Link to={routes.admin.myProfile} className={classNames(classes.headerProfileLink)}>My Profile</Link>
                <a className={classNames(classes.headerProfileLink)} onClick={logout}>Sign Out</a>
              </div>
            </div>
          </div>

          <div className={classes.headerMenu}>
            <div className={classNames(classes.headerMenuItem, { [classes.headerMenuItemActive]: this.props.location.pathname === routes.admin.dashboard })}>
              <Link to={routes.admin.dashboard} className="ant-dropdown-link">
                {t('dashboard')}
              </Link>
            </div>
            <div className={classNames(classes.headerMenuItem)}>
              <Link to='/' className="ant-dropdown-link">
                Randomization Platform
              </Link>
            </div>
            { (patientProfileReadPermission ||  SAEReadPermission || followUp90dReadPermission) && (
              <div className={classNames(classes.headerMenuItem, { [classes.headerMenuItemActive]: this.props.location.pathname.includes('/patient/') })}>
                <Dropdown overlay={menuPatients(this.props)}>
                  <a className="ant-dropdown-link">
                    Patients <Icon type="down" />
                  </a>
                </Dropdown>
              </div>)}
            { documentReadPermission && <div className={classNames(classes.headerMenuItem, { [classes.headerMenuItemActive]: this.props.location.pathname === routes.admin.documentsEditor })}>
              <Link to={routes.admin.documentsEditor} className="ant-dropdown-link">
                {t('documentManagement')}
              </Link>
            </div>}
            {(documentTrainingReadPermission || documentPublicReadPermission || auditLogReadPermission || simulationReadPermission || userTrainingReadPermission) && <div className={classes.headerMenuItem}>
              <Dropdown overlay={menuTrialResources(this.props)}>
                <a className="ant-dropdown-link">
                  Trial resources <Icon type="down" />
                </a>
              </Dropdown>
            </div>}
            {newsletterReadPermission && <div className={classNames(classes.headerMenuItem)}>
              <Link to='/admin/newsletter' className="ant-dropdown-link">
                Mailing List
              </Link>
            </div>}
            {reportsReadPermission && <div
              className={classNames(classes.headerMenuItem, {
                [classes.headerMenuItemActive]:
                this.props.location.pathname === routes.admin.reporting,
              })}
            >
              <Link to={routes.admin.reporting} className="ant-dropdown-link">
                Reporting
              </Link>
            </div>}
          </div>

        </div>
      );
    }
}

const mapStateToProps = state => ({
  token: getUserToken(state),
  patientProfileReadPermission: getPatientProfileReadPermission(state),
  SAEReadPermission: getSAEReadPermission(state),
  followUp90dReadPermission: getFollowUp90dReadPermission(state),
  adminSettingsPermission: getAdminSettingsPermission(state),
  userInfo: getUserInfo(state),
  userTrainingReadPermission: getUserTrainingReadPermission(state),
  simulationReadPermission: getSimulationReadPermission(state),
  siteReadPermission: getSiteReadPermission(state),
  roleReadPermission: getRoleReadPermission(state),
  userReadPermission: getUserReadPermission(state),
  documentReadPermission: getDocumentReadPermission(state),
  documentTrainingReadPermission: getDocumentTrainingReadPermission(state),
  documentPublicReadPermission: getDocumentPublicReadPermission(state),
  auditLogReadPermission: getAuditLogReadPermission(state),
  newsletterReadPermission: getNewsletterReadPermission(state),
  reportsReadPermission: getReportsReadPermission(state),
});
const mapDispatchToProps = {
  logout,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withNamespaces()(AdminHeader)));



// WEBPACK FOOTER //
// ./src/components/AdminHeader/AdminHeader.js